import { HCS_LOAD, HCS_PREFERENCES } from '../constants/types'

const initialState = {}

const healthCareService = (state = initialState, action: any) => {
    switch (action.type) {
        case HCS_LOAD:
            return {
                ...action.payload,
            }
        case HCS_PREFERENCES:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}

export default healthCareService
